import { render } from "./columnSetting.vue?vue&type=template&id=731c066e&scoped=true"
import script from "./columnSetting.vue?vue&type=script&lang=js"
export * from "./columnSetting.vue?vue&type=script&lang=js"

import "./columnSetting.vue?vue&type=style&index=0&id=731c066e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731c066e"],['__file',"src/components/scTable/columnSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "731c066e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('731c066e', __exports__)) {
    api.reload('731c066e', __exports__)
  }
  
  module.hot.accept("./columnSetting.vue?vue&type=template&id=731c066e&scoped=true", () => {
    api.rerender('731c066e', render)
  })

}


export default __exports__